export default __webpack_public_path__ + "assets/images/12e243b2852d8b5fb1d4ff050c2a88c1.jpg";